"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  api: {
    basePath: '/website-nav/web-api',
    routes: {
      graphiteRelatedLinks: '/v1/related-links',
      marketing: '/v1/marketing',
      previewPhoto: '/v1/preview-photo',
      userPlatformStats: '/v1/user-platform-stats',
      userSettings: '/v1/user-settings'
    }
  }
};
exports.default = _default;